import React, { Suspense, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import { useLastLocation } from 'react-router-last-location';

import { useNetworkStatus } from '@hooks';
import { ServerErrorLayout } from '@layouts';
import { homeUrl } from '@urls';

const OfflineSvg = React.lazy(() =>
  import('assets/offline.svg?react').then((m) => ({ default: m.default })),
);

export const OfflineView: React.FC<RouteComponentProps> = ({ history }) => {
  const { online } = useNetworkStatus();
  const lastLocation = useLastLocation();

  useEffect(() => {
    if (online) {
      history.push(lastLocation ? lastLocation.pathname : homeUrl);
    }
  }, [online]);

  return (
    <ServerErrorLayout
      image={
        <Suspense fallback={null}>
          <OfflineSvg />
        </Suspense>
      }
      headerText="Brak sieci"
      subHeaderText="Sprawdź swoje połączenie internetowe i spróbuj ponownie."
      backPath={online && homeUrl}
      backText="Spróbuj ponownie"
    />
  );
};
